import { FC, HTMLAttributes } from 'react';
import clx from 'classnames';
import { ReactComponent as CloseIcon } from 'src/Themes/assets/close small.svg';
import { ReactComponent as TickIcon } from 'src/Themes/assets/tick small.svg';
import st from './EditableFieldToolbarButton.module.scss';

interface IEditableFieldToolbarButtonProps extends HTMLAttributes<HTMLButtonElement> {
	type: 'cancel' | 'apply';
	disable?: boolean;
}

const EditableFieldToolbarButton: FC<IEditableFieldToolbarButtonProps> = ({
	type,
	onClick,
	className,
	disable = false,
}) => {
	return (
		<button
			onClick={onClick}
			disabled={disable}
			className={clx(st.tbButton, className, st[type])}
		>
			{type === 'apply' ? <TickIcon /> : <CloseIcon />}
		</button>
	);
};

export default EditableFieldToolbarButton;
